import { mapGetters } from 'vuex';
import FooterI18n from './Footer.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['user'])
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    goToThomasSite() {
      window.open('https://portefoliothomasdelagoutine.firebaseapp.com/', '_blank');
    },
    goToCGV() {
      window.open(process.env.VUE_APP_API_URL + '/cgv');
    },
    goToContact() {
      this.$router.push('/contact')
    }
  },

  mounted() {},

  i18n: FooterI18n,

};
